import type { RouteLocationRaw } from 'vue-router';
import { hash } from 'ohash';
import type { InferOutput } from 'valibot';
import {
  array as vArray,
  null as vNull,
  string as vString,
  undefined as vUndefined,
  union as vUnion,
  picklist as vPicklist,
} from 'valibot'; // destruct to be sure that we don't ship whole valibot library to front

// We won't be able to use  ”availableLocales” of NuxtI18n.
// it looks like the array contains only locales which translations have been loaded
// NOT all possible languages
export const LanguageSchema = vPicklist([
  `fr`,
  `en`,
]);
export type Language = InferOutput<typeof LanguageSchema>;
export const languages: Array<Language> = ['fr', 'en'] as const;

export type Dictionary<T extends string> = Record<T, Record<Language, string>>;

export function normalizeLanguage(locale: string): Language {
  return languages.includes(locale as Language) ? locale as Language : 'fr';
}

// Re-export those here as we want our source of truth to be valibot

export type NuxtRouteParamValue = InferOutput<typeof NuxtRouteParamValueSchema>;
export const NuxtRouteParamValueSchema = vUnion([
  vUndefined(),
  vString(),
  vArray(vString()),
]);

export type NuxtLocationQueryValue = InferOutput<typeof NuxtLocationQueryValueSchema>;
export const NuxtLocationQueryValueSchema = vUnion([
  vNull(),
  vString(),
]);

export type NuxtLocationQuery = InferOutput<typeof NuxtLocationQuerySchema>;
export const NuxtLocationQuerySchema = vUnion([
  NuxtLocationQueryValueSchema,
  vArray(NuxtLocationQueryValueSchema),
  vUndefined(),
]);

export type Breadcrumbs = Array<BreadcrumbItem>;
export interface BreadcrumbItem {
  to?: Exclude<RouteLocationRaw, string>
  text: string
  id: string
}

export type TextOrTranslationParams = string | [i18nKey: string, i18nParams?: Record<string, string> | { count: number }];
export interface SeoLinkItem {
  to: Exclude<RouteLocationRaw, string>
  text: TextOrTranslationParams
  id: string
};
export interface SeoSection {
  title: TextOrTranslationParams
  items: Array<SeoLinkItem>
}
export type SeoLinks = Array<SeoSection>;

export function createBreadcrumbItem(item: Omit<BreadcrumbItem, 'id'>): BreadcrumbItem {
  const breadcrumbItem: BreadcrumbItem = {
    text: item.text,
    id: hash(item.text),
  };
  if (item.to) breadcrumbItem.to = item.to;
  return breadcrumbItem;
}
